import type { Reactions } from '@src/types.ts/comment';

/**
 * Toggle `identifier`'s presence under `emoji` in a reactions map. Idempotent
 * add; remove drops the emoji key when its list empties. Returns a new map and
 * never mutates the input.
 *
 * Shared by the optimistic guess (`CommentStore`) and the server-side
 * read-modify-write (`CommentRepository`) — they must agree, so the logic lives
 * here once.
 */
export function toggleReaction(
  reactions: Reactions,
  emoji: string,
  identifier: string,
  add: boolean,
): Reactions {
  const next: Reactions = { ...reactions };
  const current = next[emoji] ?? [];
  if (add) {
    if (current.includes(identifier)) return next;
    next[emoji] = [...current, identifier];
  } else {
    const filtered = current.filter(i => i !== identifier);
    if (filtered.length === 0) delete next[emoji];
    else next[emoji] = filtered;
  }
  return next;
}
